<!--出入库汇总打印 -->
<template>
    <div v-loading="loading">
        <div id="printIORecordsContent">
            <div style="width:210mm;margin: 0 auto;color: #000;">
                <div id="top">
                    <div class="print-title-view">
                        <div class="print-title">出入库汇总表</div>
                    </div>
                </div>

                <div style="width:210mm;margin: 0 auto;" id="table">
                    <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse;table-layout:fixed;" bordercolor="#333333">
                        <thead>
                            <tr style="text-align:center;font-weight: bold;">
                                <td width="5%">
                                    <div><b>序号</b></div>
                                </td>
                                <td width="12%">
                                    <div><b>仓位</b></div>
                                </td>
                                <td width="20%">
                                    <div><b>汽配编码</b></div>
                                </td>
                                <td width="14%">
                                    <div><b>配件名称</b></div>
                                </td>
                                <td width="30%">
                                    <div><b>车型</b></div>
                                </td>
                                <td width="8%">
                                    <div><b>在仓数</b></div>
                                </td>
                                <td width="11%">
                                    <div><b>备注</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in dataList">
                                <td style="text-align:center;">{{ Number(index) + 1 }}</td>
                                <td>{{ AP.ShelfSpacesCode }}</td>
                                <td>{{ AP.APCode }}</td>
                                <td>{{ AP.GoodName }}</td>
                                <td>{{ AP.AutoSerise }}</td>
                                <td>{{ AP.Count }}</td>
                                <td></td>
                            </tr>
                            <tr style="text-align:center;font-weight: bold;">
                                <td colspan="5" style="text-align:right;">
                                    <div><b>合计:&nbsp;</b></div>
                                </td>
                                <td style="text-align:left;">&nbsp;{{ OrderAmount }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div id="foot">
                    <div style="width:200mm;padding-top: 5px;margin: 0 auto;">
                        <div style="display: inline-block;width:50%;">打印人：{{ employeeName }}</div>
                        <div style="display: inline-block;width:50%;text-align: right;">打印日期：{{ printDate }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="re-set">
                    <el-button class="btn-primary" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle"
                        >编辑标题</el-button
                    >
                    <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button size="mini" class="btn-primary" @click="handoffSort(false)">原始排序</el-button>
                <el-button size="mini" class="btn-primary btn-print-sort" @click="handoffSort(true)">仓位排序</el-button>
                <span style="font-size: 15px;margin-right: 10px;">
                    在仓数
                </span>
                <el-select size="mini" class="search-item" style="width: 80px;" v-model="Comparison" clearable placeholder="符号">
                    <el-option key=">=" label=">=" value=">="></el-option>
                    <el-option key=">" label=">" value=">"></el-option>
                    <el-option key="<=" label="<=" value="<="></el-option>
                    <el-option key="<" label="<" value="<"></el-option>
                    <el-option key="=" label="=" value="="></el-option>
                    <el-option key="!=" label="!=" value="!="></el-option>
                    <el-option key="between" label="区间" value="between"></el-option>
                </el-select>
                <el-input
                    ref="search_4"
                    class="search-item"
                    size="mini"
                    style="width: 90px"
                    v-model.trim="Invent1"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                    @focus="selectAutoHandle('search_4')"
                ></el-input>
                <el-input class="search-item" size="mini" style="width: 90px" v-model.trim="Invent2" v-if="Comparison == 'between'"></el-input>
                <el-button size="mini" class="btn-primary sort-search" @click="Sifting">筛选</el-button>
                <el-button size="mini" :class="[Comparison == 'between' ? 'btn-suprint2' : 'btn-suprint1', 'btn-primary']" @click="lodopPrint" v-if="!isDefaultSet"
                    >打印</el-button
                >
                <el-button size="mini" :class="[Comparison == 'between' ? 'btn-suprint2' : 'btn-suprint1', 'btn-primary']" v-print="'#printIORecordsContent'" v-else
                    >打印</el-button
                >
                <el-button size="mini" @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: false,
            type: Boolean
        },
        isDefaultSet: {
            default: false,
            type: Boolean
        },
        sParams: {
            type: Object
        },
        goodsList: {
            type: Array,
            default: () => {}
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: false,
            OrderAmount: 0,
            employeeName: userMsg.EmployeeName,
            printDate: '',
            searchParams: {},
            dataList: [],
            dataListParams: [],
            Comparison: '',
            Invent1: 0,
            Invent2: 0,
            isSscodeSort: true,
            company: userMsg.EntpName,
            isEditTitle: false, //编辑标题
            titleConfig: {
                RValue: userMsg.EntpName + '出入库汇总表'
            }, //标题配置
            isPreview: false
        };
    },
    watch: {},
    created() {},
    mounted() {
        if (this.isInit) {
            this.getConfigByCodes().then(() => {
                this.init(false);
            });
        }
    },
    methods: {
        init(isPrint) {
            let that = this;
            that.loading = true;
            that.OrderAmount = 0;
            that.dataList = [];
            that.dataListParams = [];

            if (that.sParams) {
                that.sParams.page = 1;
                that.searchParams = { ...that.sParams };
            } else {
                that.searchParams = { page: 1 };
            }
            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
            that.printDate = `${year1}-${month1}-${day1}`;
            that.goodsList.forEach(e => {
                if (e.SSId) {
                    let t = that.dataListParams.find(v => v.GoodsId == e.GoodsId && v.SSId == e.SSId);
                    if (!t) {
                        that.dataListParams.push({
                            GoodsId: e.GoodsId,
                            SSId: e.SSId,
                            ShelfSpacesCode: e.ShelfSpacesCode,
                            APCode: e.APCode,
                            GoodName: e.GoodName,
                            AutoSerise: e.AutoSerise,
                            Count: 0
                        });
                    }
                    //同库改仓-新仓
                    if (e.SSIdTo && e.Type == 4) {
                        let t2 = that.dataListParams.find(v => v.GoodsId == e.GoodsId && v.SSId == e.SSIdTo);
                        if (!t2) {
                            that.dataListParams.push({
                                GoodsId: e.GoodsId,
                                SSId: e.SSIdTo,
                                ShelfSpacesCode: e.ToShelfSpacesCode,
                                APCode: e.APCode,
                                GoodName: e.GoodName,
                                AutoSerise: e.AutoSerise,
                                Count: 0
                            });
                        }
                    }
                }
            });
            that.getOrders(isPrint);
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyl'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyl': //是否出现预览界面
                                    this.isPreview = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        handoffSort(data) {
            this.isSscodeSort = data;
            this.OrderAmount = 0;
            this.dataList = [];
            this.getOrders();
        },
        Sifting() {
            this.dataList = [];
            this.OrderAmount = 0;
            this.getOrders();
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            this.$refs[ref].select();
        },
        getOrders(isPrint) {
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/EntpWarehouse/GetRecordsForPrint',
                    data: {
                        GoodsList: that.dataListParams,
                        isSscodeSort: that.isSscodeSort,
                        Comparison: that.Comparison,
                        Invent1: that.Invent1,
                        Invent2: that.Invent2
                    },
                    hideLoading: that.isInit
                })
                .then(res => {
                    let data = res.data;

                    if (!data || data.length == 0) {
                        if (that.searchParams.page == 1) that.dataList = [];
                        return;
                    } else {
                        let list = [...that.dataList, ...data];
                        that.dataList = list;
                        if (that.dataList.length < res.count) {
                            that.searchParams.page++;
                            this.getOrders();
                        } else {
                            that.dataList.forEach(e => {
                                that.OrderAmount += e.Count;
                            });
                            if (that.isInit) that.loading = false;
                            else {
                                this.$nextTick(() => {
                                    setTimeout(() => {
                                        that.lodopPrint();
                                    }, 100);
                                });
                            }
                        }
                    }
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let topStyle = `
                    .print-title-view {
                        width: 762px;
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 20px 0;
                    }

                    .print-title-view .print-title {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        max-width: 50%;
                        margin: 0 auto;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                    }                   
               `;
                var tableStyle = `
                    table,
                    td,
                    th {
                        border-width: 1px;
                        border-style: solid;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;                        
                    }
                    /* 为了兼容火狐不换行 */
                    td{
                        word-break: break-all;word-wrap: break-word;
                    }                     
                    table{
                        width:100%;
                        margin: 0 auto;
                        border-top: solid 1px black;                    
                    }               
                `;
                LODOP.PRINT_INIT('出入库汇总表');
                // 设定打印项在纸张范围内的水平方向的位置锁定方式。
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
                let printContentHeight = document.getElementById('printIORecordsContent').clientHeight;
                let topHeight = document.querySelector('#printIORecordsContent #top').clientHeight;
                let tableHeight = document.querySelector('#printIORecordsContent #table').clientHeight;
                let footHeight = document.querySelector('#printIORecordsContent #foot').clientHeight;
                let printTableH = 1080 - topHeight;
                let pageFootTop = printTableH;
                if (printContentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', '');
                    pageFootTop = printContentHeight;
                    // printTableH = 950;
                }
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printIORecordsContent #top').innerHTML);
                // LODOP.ADD_PRINT_TABLE(topHeight, 0, '100%', printTableH, `<style>${tableStyle}</style>` + document.querySelector('#printIORecordsContent #table').innerHTML);
                LODOP.ADD_PRINT_TABLE(
                    topHeight,
                    0,
                    '100%',
                    `BottomMargin:0px`,
                    `<style>${tableStyle}</style>` + document.querySelector('#printIORecordsContent #table').innerHTML
                );
                LODOP.SET_PRINT_STYLEA(0, 'TableHeightScope', 2); //高度包含页头
                // //次页开始的上边距偏移量
                // LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -topHeight + 3);
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', document.querySelector('#printIORecordsContent #foot').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1);

                LODOP.ADD_PRINT_HTM(10, 690, 300, 10, "<font><span tdata='pageNO' format='#'>第#页</span> / <span tdata='pageCount' format='#'>共#页</span></font>");
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 1);
                // LODOP.ADD_PRINT_HTM(pageFootTop + 20, 15, 300, 10, '<font>应收帐列表</font>');
                // LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                // LODOP.PRINT_DESIGN();

                if (!this.isInit) this.dataList = [];
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印
            }
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        }
    }
};
</script>
<style lang="less" scoped media="print">
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 20px 0;
}

.print-title-view .print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    // justify-content: right;
    justify-content: space-between;
    margin-top: 20px;
}
.btn-ctn-left {
    display: flex;
}
.re-submit {
    float: left;
    height: 40px;
    width: 100%;
}
.sort-search {
    margin: 0 0 0 10px;
}
.btn-print-sort {
    margin: 0 30px 0 10px;
}
.search-item-dialog {
    width: 40px;
    margin: 0 5px 0 5px;
    .dialog-footer {
        text-align: right;
    }
    .el-form-item {
        margin-bottom: 0;
    }
}
.btn-suprint1 {
    margin: 0 0 0 180px;
}
.btn-suprint2 {
    margin: 0 0 0 90px;
}
table,
td,
th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
</style>
